<template>
  <div v-if="showModal" class="modal-container">
    <div class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40"></div>

    <div class="modal-content w-[550px] h-[100vh] relative bg-white m-auto flex-col flex rounded-lg z-50">
      <!-- <div class="align-right rounded-full p-2">
          <button 
            class="text-grayDark hover:text-gray-600 focus:outline-none"
            @click="closeModal"
            aria-label="Close"
          >
            <img src="@/assets/dashboard/iconoir_cancel.svg" alt="Close" class="w-4 h-4" />
          </button>           
        </div> -->

      <div class="w-full border-b-[1px] mb-4 px-6 py-4">
        <h2 class="text-[18px] text-grayDark font-bold">{{ modalTitle }}</h2>
      </div>

      <form @submit.prevent="submitModal" class="overflow-y-auto px-6 ">
        <div class="mb-4 space-y-4">

          <div class="">
            <label class="block text-[13px] font-medium text-grayDark">Project</label>
            <select v-if="!loading" v-model="selectedProjectId" placeholder="Select project"
              class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required>
              <option v-for="project in projects" :key="project.project_id" :value="project.project_id">

                <!-- ({{ project.project_name }}) -->
                {{ project.project_name }}
              </option>
            </select>
          </div>

          <div class="">
            <label class="block text-[13px] font-medium text-grayDark">How many hours did this take</label>
            <input v-model="newReports.hours_spent" type="text" placeholder="This should be a summation of all the time spent on the project for the day either for fixing bugs or implementing new features.
                "
              class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required />
          </div>
          <div class="">
            <label class="block text-[13px] font-medium text-grayDark">Daily Tasks</label>
            <textarea v-model="newReports.daily_tasks" placeholder="This can be bulleted, e.g. 
- Fixed the landing page button bug
- Implemented the signup page"
              class="mt-1 block w-full h-[152px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required></textarea>
          </div>
          <div class="">
            <label class="block text-[13px] font-medium text-grayDark">Blockers</label>
            <textarea v-model="newReports.blockers"
              placeholder=" Are there any blockers or any other information you need to pass across about the day's work?"
              class="mt-1 block w-full h-[152px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required>
              </textarea>
          </div>
          <div class="">
            <label class="block text-[13px] font-medium text-grayDark">Time spent on personal study</label>
            <input v-model="newReports.study_hours" type="text"
              placeholder="This time should be different from the total work hours from the previous questions."
              class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required />
          </div>

          <div class="">
            <label class="block text-[13px] font-medium text-grayDark">Any new concepts learned?</label>
            <textarea v-model="newReports.new_concepts"
              placeholder=" Are there any new concepts. You can be as detailed as possible."
              class="mt-1 block w-full h-[152px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
              required>
              </textarea>
          </div>



        </div>
        <div class="flex justify-end mb-4 text-[14px]">
          <button type="button" class="mr-4 py-2 px-4 bg-primaryLight border border-grayLight text-grayDark rounded"
            @click="closeModal">Cancel</button>
          <button type="submit"
            class="flex items-center  gap-2 py-2 px-4 bg-primaryDarkBg w-[146px] h-[42px] text-white rounded">
            <!-- <img src="@/assets/dashboard/add.svg" alt="User icon" class="h-4"> -->
            Submit Report
          </button>
        </div>
      </form>
    </div>

  </div>
</template>

<script>
import apiClient from '@/axios'


export default {
  name: 'ProgressReportModal',
  components: {},
  props: {
    showModal: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      projects: [],
      selectedProjectId: null,
      modalTitle: 'Submit progress reports',
      reports: [],

      newReports: {
        daily_tasks: '',
        hours_spent: '',
        blockers: '',
        study_hours: '',
        new_concepts: '',
      }
    }
  },
  watch: {
    showModal(newVal) {
      if (newVal) {
        this.fetchProjects();
      }
    }
  },

  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
    isInvestor() {
      return this.$store.getters.isInvestor
    },
  },
  methods: {
    closeModal() {
      this.$emit('close') // Emit close event to parent
      this.clearErrorMessage(); // Clear error message on modal close
    },
    // Clear the message
    clearErrorMessage() {
      // Clearing moved to toast
    },

    async submitModal() {
      try {
        const reportData = {
          daily_tasks: this.newReports.daily_tasks,
          hours_spent: parseInt(this.newReports.hours_spent) || 0,
          blockers: this.newReports.blockers,
          study_hours: parseInt(this.newReports.study_hours) || 0,
          new_concepts: ""
        };

        console.log('Submitting report data:', reportData);

        // Fix the API endpoint to match the correct format with query parameter
        const response = await apiClient.post(`/web/progress_report?project_id=${this.selectedProjectId}`, reportData);

        console.log('Report Submitted:', response.data);

        if (response.data.status_code === 202) {
          this.$toast.success(response.data.message || 'Duplicate progress report submission detected; data stored for review.');
        } else {
          this.$toast.success(response.data.message || 'Report submitted successfully!');
        }
          this.$emit('reportSubmitted', response.data.message || 'Report submitted successfully!');

        this.closeModal(); // Close the modal
        this.$router.push({ name: 'ProgressReports' });

      } catch (error) {
        console.error('Error submitting report:', error);

        if (error.response) {
          this.$toast.error(error.response.data.message || 'Error submitting report');
        } else {
          this.$toast.error('An unexpected error occurred while submitting report.');
        }
      }
    },
    async fetchProjects() {
      this.loading = true
      try {
        let response;
        if (this.isManager) {
          // Fetch projects managed by the manager
          response = await apiClient.get(`/web/manager/me`);
          const managerData = response.data.data[0]; // Assuming there's only one manager in the response

          // Store the projects from the manager's data
          this.projects = managerData.projects || [];
        } else if (this.isAdmin) {
          // Fetch all projects if the user is an admin
          response = await apiClient.get('/web/projects_all');
          this.projects = response.data.data || [];
        } else if (this.isTalent) {
          // Fetch projects related to the talent
          response = await apiClient.get('/web/talent/me');
          this.projects = response.data.data.projects || [];
          console.log('projects retrieved')
        }
      } catch (error) {
        console.error('Error fetching projects:', error);
      } finally {
        this.loading = false;
      }
    },

  },
  created() {
    this.fetchProjects();
  }
}
</script>

<style scoped>
.modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  z-index: 50;
}

.smoke-light {
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  position: relative;
  z-index: 60;
}
</style>